import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button } from '@fiverr-private/fit';
import { PARTIAL_DELIVERY_RESOLUTION_STEP, DISSATISFIED_QUALITY_STEP, RECEIVED_NOTHING_STEP, NEED_REVISIONS_STEP } from '../PreRevisionWizard/const';
import { getOnRevisionRejection } from '../../selectors/callbacks';
import * as Translations from '../../providers/i18n';
import './style.scss';

const answers = [
    {
        translationKey: 'still_need_revisions',
        forwardToStep: NEED_REVISIONS_STEP
    },
    {
        translationKey: 'received_partial_delivery',
        forwardToStep: PARTIAL_DELIVERY_RESOLUTION_STEP
    },
    {
        translationKey: 'dissatisfied_with_quality',
        forwardToStep: DISSATISFIED_QUALITY_STEP
    },
    {
        translationKey: 'did_not_receive_anything',
        forwardToStep: RECEIVED_NOTHING_STEP
    }
];

const PreRevisionRejectionReasons = ({ onReasonSelect, onRevisionRejection, goBack, i18n }) => {

    const getTranslatedText = (translationKey) => i18n.t(`attachments_preview.pre_revision.why_delivery_ready.${translationKey}`);

    const onButtonClick = (translationKey, forwardToStep) => {
        onRevisionRejection(getTranslatedText(translationKey));
        onReasonSelect(forwardToStep);
    };

    return (
        <div className="pre-revision-rejection-reasons">
            <p>
                {i18n.t('attachments_preview.pre_revision.why_delivery_ready.question')}
            </p>
            {answers.map(({ translationKey, forwardToStep, ...restProps }, index) => (
                <Button key={index} className="btn-answer"
                    color="grey" fill="ghost" onClick={() => onButtonClick(translationKey, forwardToStep)} {...restProps}>
                    {getTranslatedText(translationKey)}
                </Button>
            ))}
            <small>
                <a className="link-back" onClick={goBack}>
                    {i18n.t('attachments_preview.general.back')}
                </a>
            </small>
        </div>
    );
};

PreRevisionRejectionReasons.propTypes = {
    onReasonSelect: PropTypes.func.isRequired,
    onRevisionRejection: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

const mapStateToProps = (state) => ({
    onRevisionRejection: getOnRevisionRejection(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(PreRevisionRejectionReasons);
